import { render, staticRenderFns } from "./DollarIcon.vue?vue&type=template&id=022164f6&"
import script from "./DollarIcon.vue?vue&type=script&lang=js&"
export * from "./DollarIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports